module.exports = __webpack_public_path__ + "static/media/test_info.46c9f62c.png";